import { InstitEvolucaoFiltrosDTO } from '@/interfaces/crm-institution-evolution';
import { ENDPOINTS } from '@/settings/api-settings';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';

export function listCrmInstitutionEvolutionMonthOptions(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_EVOLUTION_MONTHS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    })
  );
}

export function listCrmInstitutionEvolutionChartsData(filters: InstitEvolucaoFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_EVOLUTION, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    })
  );
}

